import React from 'react';
import { createRoot } from 'react-dom/client';
import { UIProvider } from './ui/index.js';
import './styles.css';
import App from './App.jsx';
import { WebsiteOnboarding } from './features/onboarding/WebsiteOnboarding.jsx';
import { TeamLeads } from './features/team/TeamLeads.jsx';
import { BookingPage } from './features/onboarding/BookingPage.jsx';
import { PrivacyPage } from './features/legal/PrivacyPage.jsx';

const route = location.pathname.replace(/\/$/, '');
const team = route === '/ekip', booking = route === '/randevu', panel = route === '/panel', privacy = route === '/gizlilik';
// /panel always opens the brand panel, also where the site lands on onboarding (LANDING=onboarding).
const onboarding = booking || privacy || !team && !panel && (route === '/onboarding' || document.querySelector('meta[name="bs-landing"]')?.content === 'onboarding');
// Visitor pages read at the public type scale; set on <html> so portalled dialogs inherit it.
if (onboarding) document.documentElement.dataset.bsScale = 'public';

createRoot(document.getElementById('root')).render(
  <UIProvider>
    {team ? <TeamLeads /> : privacy ? <PrivacyPage /> : booking ? <BookingPage /> : onboarding ? <WebsiteOnboarding /> : <App />}
  </UIProvider>,
);
